import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../helpers/JsonMapper";
import Image from "../image/Image";
import ImageCollection from "../image/ImageCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class ProductScraper extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [ProductScraper.short_product_name_attribute_name]: null,
      [ProductScraper.description_attribute_name]: null,
      [ProductScraper.gallery_attribute_name]: ImageCollection,
      [ProductScraper.main_image_attribute_name]: Image,
      [ProductScraper.sku_attribute_name]: null,
      [ProductScraper.private_notes_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getShortProductNameAttributeName() {
    return this.short_product_name_attribute_name;
  }
  static getDescriptionAttributeName() {
    return this.description_attribute_name;
  }
  static getGalleryAttributeName() {
    return this.gallery_attribute_name;
  }
  static getMainImageAttributeName() {
    return this.main_image_attribute_name;
  }
  static getSkuAttributeName() {
    return this.sku_attribute_name;
  }
  static getPrivateNotesAttributeName() {
    return this.private_notes_attribute_name;
  }
  getShortProductName() {
    return this.getAttribute(ProductScraper.getShortProductNameAttributeName());
  }
  getDescription() {
    return this.getAttribute(ProductScraper.getDescriptionAttributeName());
  }
  getGallery() {
    return this.getAttribute(ProductScraper.getGalleryAttributeName());
  }
  getMainImage() {
    return this.getAttribute(ProductScraper.getMainImageAttributeName());
  }
  getSku() {
    return this.getAttribute(ProductScraper.getSkuAttributeName());
  }
  getPrivateNotes() {
    return this.getAttribute(ProductScraper.getPrivateNotesAttributeName());
  }
}
_defineProperty(ProductScraper, "ALIEXPRESS_PLATFORM", 'aliexpress');
_defineProperty(ProductScraper, "AMAZON_PLATFORM", 'amazon');
_defineProperty(ProductScraper, "SHOPIFY_PLATFORM", 'shopify');
_defineProperty(ProductScraper, "short_product_name_attribute_name", 'short_product_name');
_defineProperty(ProductScraper, "description_attribute_name", 'description');
_defineProperty(ProductScraper, "gallery_attribute_name", 'gallery');
_defineProperty(ProductScraper, "main_image_attribute_name", 'main_image');
_defineProperty(ProductScraper, "sku_attribute_name", 'sku');
_defineProperty(ProductScraper, "private_notes_attribute_name", 'private_notes');